/**
 * OPLYX — Brand Constants (Single Source of Truth)
 *
 * To rename the product in the future, change ONLY this file.
 * No other UI string should hardcode "OPLYX" or "Oplyx".
 */

export const BRAND = {
  name: "OPLYX",
  fullName: "OPLYX",
  legacyName: "Oplyx",
  tagline: "Run your business. We run the operation.",
  taglinePt: "Oplyx é a camada operacional que conecta e organiza cada parte do seu negócio em tempo real, transformando operação em dados e dados em decisões.",
  domain: "oplyx.com",
  pillars: [
    "Operação contínua",
    "Tudo conectado",
    "Dados que geram decisões",
    "Confiança e controle",
  ],
};

export const BRAND_COLORS = {
  green: "#00FF88",
  greenAlt: "#2DFF85",
  black: "#0B0D0F",
  elevated: "#121417",
  grafite: "#1A1C1E",
  cinza: "#6B7280",
  cinzaClaro: "#E5E7EB",
};

/**
 * Identificação da empresa (Decreto 7.962/2013, art. 2º): razão social, CNPJ e
 * endereço físico aparecem no rodapé do site e nos documentos legais.
 * Única fonte: rodapé da landing, Termos de Uso e Política de Privacidade.
 */
export const COMPANY = {
  razaoSocial: "OPLYX TECNOLOGIA DA INFORMACAO LTDA",
  cnpj: "66.713.966/0001-84",
  // Endereço completo da sede, como no cartão CNPJ. Vazio = mostra só a cidade.
  endereco: "Rua Sebastião Laurentino da Silva, 170, Córrego Grande, CEP 88037-400",
  cidade: "Florianópolis/SC",
  emailSuporte: "suporte@oplyx.com.br",
  emailPrivacidade: "privacidade@oplyx.com.br",
  whatsapp: "+55 48 99120-7631",
};

export const companyAddress = () =>
  COMPANY.endereco ? `${COMPANY.endereco}, ${COMPANY.cidade}` : COMPANY.cidade;
